import { Component, inject } from '@angular/core';
import { AppService } from '../../app.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'request-failure',
	standalone: true,
	imports: [TranslateModule],
	templateUrl: './failure.component.html',
	styleUrl: './failure.component.scss'
})
export class FailureComponent {
	public readonly appService = inject(AppService);
}
